"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("@mui/styles");
const types_1 = require("../types");
const use_dimensions_1 = __importDefault(require("../@common/hooks/use-dimensions"));
const ApplicationFrame = ({ url, aspectRatio, staticHeightAdjust = 0, onMount, onLoad, title = '', options }) => {
    const isFullScreen = options === null || options === void 0 ? void 0 : options.fullScreen;
    const { applicationFrame, enclosingDiv } = useStyles({ fullScreen: isFullScreen });
    // if no aspect ratio is received, the iframe will use the window dimensions
    const [{ height, width }, setHeightAndWidth] = use_dimensions_1.default();
    const updateDimensions = react_1.useCallback(() => {
        if (isFullScreen || aspectRatio)
            setHeightAndWidth(isFullScreen ? types_1.FULL_SCREEN : aspectRatio, staticHeightAdjust);
    }, [aspectRatio, staticHeightAdjust, isFullScreen]);
    const handleOnMount = react_1.useCallback(() => {
        if (onMount) {
            onMount();
        }
    }, [onMount]);
    const query = matchMedia('screen and (orientation:portrait)');
    query.onchange = _ => {
        updateDimensions();
    };
    react_1.useEffect(() => {
        handleOnMount();
        updateDimensions();
    }, [updateDimensions, handleOnMount]);
    return (react_1.default.createElement("div", { className: enclosingDiv },
        react_1.default.createElement("iframe", { title: title, style: { width, height }, src: url, className: applicationFrame, onLoad: onLoad })));
};
exports.default = ApplicationFrame;
const useStyles = styles_1.makeStyles(() => {
    return {
        applicationFrame: {
            display: 'block',
            border: '1px solid #000'
        },
        enclosingDiv: {
            border: '1px solid #98b2c0',
            position: 'relative',
            height: ({ fullScreen }) => fullScreen ? '100vh' : 'auto',
            width: ({ fullScreen }) => (fullScreen ? '100vw' : 'auto')
        }
    };
});
